module.exports = __webpack_public_path__ + "img/Frame3.26a44d39.png";